module.exports = __webpack_public_path__ + "static/ruta-2a334812ffc5650f680203a7fa5254c7.png";